import React, { useEffect } from "react";

import { Input, GooglePlacesAutoComplete, Button, Checkbox } from "../..";

import { INVALID_ADDRESS_MESSAGE } from "../../../constants/constants";

import styles from "./index.module.css";
import RideRequestFields from "../../common/RideRequestFields/RideRequestFields";
import { useSelector } from "react-redux";

export const CreateHO = ({
  personalInfoFieldsDisabled,
  switchAdmin,
  handleUpdateAdmin,
  values,
  handleSelectAddress,
  handleChangeAddress,
  handleChangeAdmin,
  handleInviteUser,
  parentOrgId,
  disableEnterpriseCheckbox,

  ...rest
}) => {
  console.log('CreateHO parentOrgId', parentOrgId);
  const user = useSelector((state) => state.authorization.user);
  const { validateForm } = rest;
  useEffect(() => {
    validateForm();
  }, [values?.location])
console.log('values?.isEnterprise', values?.isEnterprise);
console.log('values user', user);

  return (
    <>
      <label className={styles.name}>
        <span className={styles.required}>Company Name</span>
        <Input name="name" type="text" placeholder="Organization Name" />
      </label>
      <label className={styles.organizationLocation}>
        <span className={styles.required}>Address</span>
        <GooglePlacesAutoComplete
          name="location.formattedAddress"
          value={values?.location?.formattedAddress}
          handleSelectAddress={handleSelectAddress}
          handleChangeAddress={handleChangeAddress}
        />
        {rest.touched &&
          rest.touched["location.formattedAddress"] &&
          rest.errors.location && (
            <div className={styles.errorMessage}>{INVALID_ADDRESS_MESSAGE}</div>
          )}
      </label>
      {(user.isTest && !values?.parentOrgId) && (
        <div className={styles.enterpriseContainer}>
          <Checkbox 
            name="isEnterprise" 
            checked={values?.isEnterprise}
            disabled={disableEnterpriseCheckbox}
            onChange={({setFieldValue, name, checked}) => {
              setFieldValue(name, checked);
              // When toggling enterprise off, clear enterprise-only flags
              if (checked) {
                setFieldValue('addons', {insightsEnabled: true});
              } else {
                setFieldValue('addons', {});
              }
            }}
          /> 
          <span className={styles.enterpriseLabel}>Is Enterprise Organization</span>
        </div>
      )}

      {(user.isTest && !values?.parentOrgId) &&
      (
        <div className={styles.enterpriseFeaturesContainer}>
          <div className={styles.enterpriseFeaturesHeader}>
            <span className={styles.enterpriseFeaturesTitle}>Addon Features</span>
            <span className={styles.enterpriseFeaturesSubtitle}>Turn features on for organization</span>
          </div>

          <div className={styles.featureRow}>
            <div>
              <div className={styles.featureName}>MedHaul Insights</div>
              <div className={styles.featureDescription}>Advanced analytics and reporting for organization rides and usage</div>
            </div>
            <div className={styles.featureControl}>
              <Checkbox
                name="addons.insightsEnabled"
                // disabled={values?.isEnterprise && disableEnterpriseCheckbox}
                checked={values?.addons?.insightsEnabled}
                onChange={({setFieldValue, name, checked}) => setFieldValue(name, checked)}
              />
            </div>
          </div>

          {/* <div className={styles.featureRow}>
            <div>
              <div className={styles.featureName}>Codi</div>
              <div className={styles.featureDescription}>Enable Codi integrations and features for the organization</div>
            </div>
            <div className={styles.featureControl}>
              <Checkbox
                name="addons.codiEnabled"
                checked={values?.addons?.codiEnabled}
                onChange={({setFieldValue, name, checked}) => setFieldValue(name, checked)}
              />
            </div>
          </div> */}
        </div>
      )}
      <div className={styles.name}>
        <label className={styles.nameLabel}>
          <span className={styles.required}>Administrator's First Name</span>
          <Input
            name="admin.firstName"
            type="text"
            placeholder="Administrator's First Name"
            disabled={personalInfoFieldsDisabled}
          />
        </label>
        <label className={styles.nameLabel}>
          <span className={styles.required}>Administrator's Last Name</span>
          <Input
            name="admin.lastName"
            type="text"
            placeholder="Administrator's Last Name"
            disabled={personalInfoFieldsDisabled}
          />
        </label>
      </div>

      <div className={styles.emailContainer}>
        <label className={styles.email}>
          <span className={styles.required}> Admin's Email</span>
          <Input
            name="admin.email"
            type="text"
            placeholder="Admin's Email"
            disabled={personalInfoFieldsDisabled}
          />
        </label>
        {switchAdmin && (
          <div className={styles.changeAdminBtn}>
            <Button
              myClassName={styles.formControlBtn}
              onClick={handleChangeAdmin}
            >
              Switch Admin
            </Button>
          </div>
        )}
      </div>
      {switchAdmin && (
        <div className={styles.inviteBtn}>
          <Button
            myClassName={styles.formControlBtn}
            onClick={handleInviteUser}
          >
            Invite New User
          </Button>
        </div>
      )}
      <div>
        <div className={styles.checkboxesColumn}>
          <label className={styles.rideRequestFieldsHead}>
            Included Ride Request fields
          </label>
          {values && RideRequestFields(values, false, rest.setValues)}
        </div>
      </div>
    </>
  );
};
